import { LikeDTO } from '../models/post'

interface PasswordRuleInterface {
    id: number
    rule: string
    checked: boolean
}

export interface CheckRules {
    lowerCase: boolean
    upperCase: boolean
    number: boolean
    specialCharacter: boolean
    long: boolean
    notBlankSpace: boolean
    samePassword: boolean
}

interface Props {
    checked: CheckRules
}

export const DEFAULT_CHECKS = {
    lowerCase: false,
    upperCase: false,
    number: false,
    specialCharacter: false,
    long: false,
    notBlankSpace: true,
    samePassword: false,
}

const PasswordTooltip = ({ checked = DEFAULT_CHECKS }: Props) => {
    const rules: PasswordRuleInterface[] = [
        { id: 0, rule: 'Al menos una letra minúscula', checked: checked.lowerCase },
        { id: 1, rule: 'Al menos una letra mayúscula', checked: checked.upperCase },
        { id: 2, rule: 'Al menos un número', checked: checked.number },
        {
            id: 3,
            rule: 'Al menos un caracter especial (!@#$%^&*)',
            checked: checked.specialCharacter,
        },
        { id: 4, rule: 'Al menos 8 caracteres', checked: checked.long },
        { id: 5, rule: 'No debe contener espacios', checked: checked.notBlankSpace },
        { id: 6, rule: 'Las contraseñas deben coincidir', checked: checked.samePassword },
    ]

    return (
        <div className="flex flex-col">
            <span className="flex text-base mt-2">
                La contraseña debe cumplir con los siguientes requerimientos:
            </span>
            <ul>
                {rules.map((ruleItem) => (
                    <li
                        className="text-s w-[250px]"
                        key={ruleItem.id}
                    >
                        {ruleItem.rule}{' '}
                        {ruleItem.checked && <span className="text-success">✓</span>}
                    </li>
                ))}
            </ul>
        </div>
    )
}

interface LikesTooltipProps {
    likes: LikeDTO[]
}

const LikesTooltip = ({ likes }: LikesTooltipProps) => {
    return (
        <>
            {likes.length > 0 && (
                <div className="flex flex-col px-4">
                    {likes.slice(0, 5).map((like) => (
                        <span key={like.user.email}>
                            {like.user.firstName + ' ' + like.user.lastName}
                        </span>
                    ))}
                </div>
            )}
            {likes.length > 5 && (
                <div className="flex flex-col px-4">{`${likes.length - 5} más`}</div>
            )}
        </>
    )
}

export { PasswordTooltip, LikesTooltip }
